const { useRef, useEffect } = require('react');

const useScrollTo = (hasToScroll) => {
  const ref = useRef(null);

  useEffect(() => {
    if (hasToScroll) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hasToScroll]);

  return { ref };
}

export default useScrollTo;